import { render, staticRenderFns } from "./checkEditorKneeHurt.vue?vue&type=template&id=54b12ca2&scoped=true&"
import script from "./checkEditorKneeHurt.vue?vue&type=script&lang=js&"
export * from "./checkEditorKneeHurt.vue?vue&type=script&lang=js&"
import style0 from "./checkEditorKneeHurt.vue?vue&type=style&index=0&id=54b12ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b12ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b12ca2')) {
      api.createRecord('54b12ca2', component.options)
    } else {
      api.reload('54b12ca2', component.options)
    }
    module.hot.accept("./checkEditorKneeHurt.vue?vue&type=template&id=54b12ca2&scoped=true&", function () {
      api.rerender('54b12ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkEditorKneeHurt.vue"
export default component.exports